import * as R from 'ramda'
import { NOT_ACCESS_MESSAGE } from 'src/constants'
import { formatAmountForDisplay, formatDate, toCents } from 'src/utils'
import {
  actions,
  actionsByState
} from '../components/list/invoice-actions-by-state'
import * as types from './types'

function convertAmount(amount) {
  return amount ? toCents(amount) : null
}

export default {
  [types.TOOLTIP_MESSAGES](_, getters) {
    const hasPermission = getters.hasPermission

    return {
      addInvoice: !hasPermission.uploadInvoice
        ? NOT_ACCESS_MESSAGE
        : 'Add Invoice',
      sellInvoices: !hasPermission.sellInvoice
        ? NOT_ACCESS_MESSAGE
        : 'Sell Invoices',
      recheckInvoice: !hasPermission.recheckInvoice
        ? NOT_ACCESS_MESSAGE
        : 'Re-check invoice',
      recheckInvoices: !hasPermission.recheckInvoice
        ? NOT_ACCESS_MESSAGE
        : 'Re-check Selected Invoices',
      rejectInvoices: !hasPermission.rejectInvoice
        ? NOT_ACCESS_MESSAGE
        : 'Reject Selected Invoices',
      exportInvoice: !hasPermission.exportInvoice
        ? NOT_ACCESS_MESSAGE
        : 'Export Invoice List',
      cancelInvoice: !hasPermission.rejectInvoice
        ? NOT_ACCESS_MESSAGE
        : 'Cancel invoice',
      writeOffInvoice: !hasPermission.writeOffInvoice
        ? NOT_ACCESS_MESSAGE
        : 'Write off invoice'
    }
  },
  [types.INVOICES_TO_SHOW](state) {
    return state.invoices.map((invoice) => {
      return {
        amount: invoice.amount,
        formattedAmount: formatAmountForDisplay(
          invoice.amount,
          invoice.currency
        ),
        counterpartyCountry: invoice.counterparty_country,
        counterpartyGrade: invoice.counterparty_grade,
        counterpartyId: invoice.counterparty_id,
        counterpartyName: invoice.counterparty_name,
        counterpartyRegistrationNumber:
          invoice.counterparty_registration_number,
        createdAt: invoice.created_at,
        formattedCreatedAt: formatDate(invoice.created_at, 'DD/MM/YYYY'),
        creditNoteIds: invoice.credit_note_ids,
        currency: invoice.currency,
        customerCountry: invoice.customer_country,
        customerGrade: invoice.customer_grade,
        customerId: invoice.customer_id,
        customerName: invoice.customer_name,
        customerRegistrationNumber: invoice.customer_registration_number,
        dueDate: invoice.due_date,
        formattedDueDate: formatDate(invoice.due_date, 'DD/MM/YYYY'),
        id: invoice.id,
        number: invoice.number,
        partnerId: invoice.partner_id,
        partnerName: invoice.partner_name,
        saleCheck: invoice.sale_check,
        saleState: invoice.sale_state,
        state: invoice.state,
        comments: invoice.comments,
        isProductActive: invoice.is_product_active
      }
    })
  },
  [types.PARAMS_TO_SEND](state) {
    return {
      limit: state.pagination.itemsPerPage,
      offset: (state.pagination.page - 1) * state.pagination.itemsPerPage,
      descending: state.pagination.sortDesc[0],
      sortBy: state.pagination.sortBy[0],
      ...state.filters,
      amountFrom: convertAmount(state.filters.amountFrom),
      amountTo: convertAmount(state.filters.amountTo)
    }
  },
  [types.FILTERED_COLUMNS_ORDER](state) {
    return state.columnsOrder.filter((column) => column.isSelected)
  },
  [types.ORDERED_TABLE_HEADERS](state, getters) {
    return getters[types.FILTERED_COLUMNS_ORDER].reduce((agg, column) => {
      const foundColumn = state.tableHeaders.find((d) => column.key === d.key)

      if (foundColumn) {
        agg.push(foundColumn)
      }

      return agg
    }, [])
  },
  [types.SELECTED_INVOICES_BY_ACTIONS](state) {
    return state.selectedRows.reduce(
      (agg, item) => {
        const itemBulkActions = actionsByState[item.state].bulkActions

        itemBulkActions.forEach((action) => {
          agg[action].push(item)
        })

        return agg
      },
      {
        [actions.REJECT]: [],
        [actions.CANCEL]: [],
        [actions.EXPORT]: [],
        [actions.RECHECK]: [],
        [actions.APPROVE]: []
      }
    )
  },
  [types.SELECTED_INVOICES_WITH_ACTIONS](state, getters) {
    return state.selectedAction
      ? getters[types.SELECTED_INVOICES_BY_ACTIONS][state.selectedAction]
      : []
  },
  [types.SELECTED_INVOICES_WITH_NO_ACTIONS](state, getters) {
    return state.selectedAction
      ? R.difference(
          state.selectedRows,
          getters[types.SELECTED_INVOICES_WITH_ACTIONS]
        )
      : []
  },
  [types.ARE_TABLE_CHECKBOXES_DISABLED](state) {
    return state.isTableSelectAllMode ? true : state.isWarningRowShown
  }
}
